/**
 * Chummys pair — <chummys-pair>
 * Reveals the panels on arrival and writes the coming three months onto the
 * subscription stack, so the picture is always this month, next, and the one
 * after — a standing order, not a stock photo.
 */
(() => {
  if (customElements.get('chummys-pair')) return;
  class ChummysPair extends HTMLElement {
    connectedCallback() {
      const chips = this.querySelectorAll('[data-month-offset]');
      if (chips.length) {
        const now = new Date();
        chips.forEach((c) => { const d = new Date(now.getFullYear(), now.getMonth() + Number(c.dataset.monthOffset || 0), 1); c.textContent = d.toLocaleString('en-GB', { month: 'short' }); });
      }
      this.io = new IntersectionObserver((entries) => {
        for (const e of entries) if (e.isIntersecting) { this.classList.add('is-in'); this.io.disconnect(); }
      }, { threshold: 0.15 });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  }
  customElements.define('chummys-pair', ChummysPair);
})();
